import { FormValue } from 'informed';

import { Institute } from '@nw/shared/config';

export const getInstituteDetailsFromInstituteId = (
  instituteId: string,
  institutes: Array<Institute>
) => institutes.find((institute) => institute.institute_id === instituteId);

export const getInstituteIdFromInstituteName = (
  instituteName: FormValue<string>,
  institutes: Array<Institute>
) =>
  institutes.find((institute) => institute.institute_name === instituteName)
    ?.institute_id;

export const getInstituteNameFromInstituteId = (
  instituteId: string,
  institutes: Array<Institute>
) =>
  institutes.find((institute) => institute.institute_id === instituteId)
    ?.institute_name;
